import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scSecondsToMinutesNumber',
  standalone: true,
})
export class SecondsToMinutesNumberPipe implements PipeTransform {
  transform(seconds: string): string {
    return (parseFloat(seconds) / 60).toString();
  }
}
